module.exports = __webpack_public_path__ + "assets/img/arrow.f3e9ed5fee240205936106f7ea1cbe35.svg";